const BedIcon = ({ color = "#31493C", ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill={color}
      stroke="none"
    >
      <path
        d="M804 4311 c-47 -12 -133 -62 -160 -94 -14 -17 -37 -53 -52 -81 l-27
-51 -3 -721 -3 -722 -47 -7 c-59 -8 -155 -59 -188 -98 -14 -16 -37 -53 -52
-81 l-27 -51 -3 -362 -3 -363 -55 0 c-45 0 -59 -4 -79 -25 -25 -24 -25 -26
-25 -215 0 -189 0 -191 25 -215 20 -21 34 -25 80 -25 l55 0 0 -175 c0 -173 0
-176 25 -200 23 -24 28 -25 175 -25 197 0 184 -12 230 223 l34 177 1856 0
1856 0 34 -178 c46 -234 33 -222 230 -222 147 0 152 1 175 25 25 24 25 27 25
200 l0 175 55 0 c46 0 60 4 80 25 25 24 25 26 25 215 0 189 0 191 -25 215 -20
21 -34 25 -79 25 l-55 0 -3 362 -3 363 -34 63 c-19 35 -48 74 -64 88 -45 38
-117 71 -169 79 l-47 7 -3 722 -3 721 -34 63 c-38 70 -69 100 -145 140 l-51
27 -1745 2 c-960 0 -1759 -2 -1776 -6z m3500 -165 c18 -8 46 -31 62 -52 l29
-37 3 -709 2 -708 -79 0 -79 0 -4 203 c-3 196 -4 203 -30 253 -40 76 -70 107
-140 145 l-63 34 -565 0 -565 0 -51 -27 c-76 -40 -107 -70 -145 -140 l-34 -63
-3 -202 -4 -203 -78 0 -78 0 -4 203 c-3 196 -4 203 -30 253 -40 76 -70 107
-140 145 l-63 34 -565 0 -565 0 -51 -27 c-76 -40 -107 -70 -145 -140 l-34 -63
-3 -202 -4 -203 -79 0 -79 0 0 694 c0 468 3 704 11 723 14 37 47 73 84 89 46
20 3440 20 3489 0z m-2080 -1040 c18 -8 46 -31 62 -52 l29 -37 3 -189 3 -188
-640 0 -641 0 0 174 c0 181 6 214 43 255 46 50 46 50 595 51 416 0 519 -3 546
-14z m1760 0 c18 -8 46 -31 62 -52 l29 -37 3 -189 3 -188 -640 0 -641 0 0 174
c0 181 6 214 43 255 46 50 46 50 595 51 416 0 519 -3 546 -14z m640 -640 c18
-8 46 -31 62 -52 l29 -37 3 -349 3 -348 -2161 0 -2160 0 0 334 c0 347 2 370
43 415 49 53 -71 50 2115 51 1716 0 2038 -2 2066 -14z m256 -1026 l0 -80
-2320 0 -2320 0 0 80 0 80 2320 0 2320 0 0 -80z m-4343 -267 c-3 -16 -13 -70
-23 -120 l-18 -93 -48 0 -48 0 0 120 0 120 71 0 72 0 -6 -27z m4183 -93 l0
-120 -48 0 -48 0 -18 93 c-10 50 -20 104 -23 120 l-5 27 71 0 71 0 0 -120z"
      />
    </g>
  </svg>
);

export default BedIcon;
